// extracted by mini-css-extract-plugin
module.exports = {"banner-geo-ip-component":"BannerGeoIp_banner-geo-ip-component__w8ko7"};